import React from "react";
import { InputContainer,Label,TheInput } from "./styles";

function Input({value,setValue,labelText,type,width}) {
  return <InputContainer>
    {labelText && <Label>{labelText}</Label>}
    <TheInput width={width}type={type} value={value} onChange={(e)=>{setValue(e.target.value,e)}}/>
  </InputContainer>;
}
export default Input;